import { FC } from "react"

interface IProps {
    isTyping: boolean
}
const TypingIndicator: FC<IProps> = ({ isTyping }) => {
    return (
        isTyping ?
            <div className="relative p-3 ml-6 mb-4 rounded-xl">
                <div className="typing__dot float-left w-2 h-2 mr-1 bg-gray-600 rounded-full animate-threeBounce  "></div>
                <div className="typing__dot float-left w-2 h-2 mr-1 bg-gray-600 rounded-full animate-doubleBounce "></div>
                <div className="typing__dot float-left w-2 h-2 mr-1 bg-gray-600 rounded-full animate-circleBounceDelay "></div>
            </div> : <></>
    )
}
export default TypingIndicator;